export const CHAT_REALTIME_BUFFER_MAX_EVENTS = 500;
export const CHAT_REALTIME_BUFFER_MAX_BYTES = 2 * 1024 * 1024;

export function appendRealtimeBuffer(buffer, event, bufferedBytes, eventBytes) {
    const nextBytes = bufferedBytes + Math.max(0, Number(eventBytes) || 0);
    if (buffer.length >= CHAT_REALTIME_BUFFER_MAX_EVENTS || nextBytes > CHAT_REALTIME_BUFFER_MAX_BYTES) {
        return {overflow: true, bufferedBytes: 0};
    }
    buffer.push(event);
    return {overflow: false, bufferedBytes: nextBytes};
}
